<template>
  <div class="backgroud-white">
    <div class="backgroud-gray-popup popup-content-area-small text-center" v-loading="isLoading">
      <el-upload drag :action="url" name="source_video" :data="params" :before-upload="beforeUpload" :on-success="onUploadSuccess" :on-error="onUploadError"
        :on-change="onFileChange" :on-progress="onProgress" ref="upload" :auto-upload="true" v-loading="isUploading" :element-loading-text="uploadingText"
        element-loading-spinner="el-icon-loading" :multiple="false" :disabled="uploadDisabled" :show-file-list="false" :class="{'cs-disabled':uploadDisabled}">
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <div class="el-upload__tip" slot="tip">
          <span v-if="type === 1">上传讲解视频</span>
          <span v-else>上传课节视频({{ dataIn.weekLabel }})</span>
        </div>
        <div class="el-upload__tip cs-upload-warning" slot="tip" v-if="isReplace">
          <span>该课节已上传视频</span>
          <span>上传时间: {{uploadTime}}</span>
        </div>
      </el-upload>
      <div>
        <div v-if="displayProgress" class="cs-upload-item">
          <div>
            <i class="el-icon-document"></i>
            <span>{{ fileData.name }}</span>
            <span>{{ convertFileSize(fileData.size) }}</span>
            <span class="cs-color-green" v-if="fileData.successFlag">上传成功!</span>
          </div>
          <div>
            <el-progress :text-inside="true" :stroke-width="24" :percentage="fileData.progressPercent"></el-progress>
          </div>
        </div>
      </div>
    </div>
    <div slot="footer" class="dialog-footer popup-footer">
      <el-row>
        <el-col class="footer-left">
          <span v-if="!showError"></span>
          <el-alert :closable="false" v-if="showError" v-bind:title="errorMessage" type="error" show-icon></el-alert>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.footer-right {
  float: right;
}
.cs-upload-warning {
  font-size: 1rem;
  font-weight: bold;
  span {
    display: block;
  }
}
.cs-upload-item {
  display: flex;
  flex-direction: column;
  margin-top: 5px;

  span {
    display: inline-block;
    margin-left: 5px;

    &:first-of-type {
      margin-left: 1px;
    }
  }
}
.cs-disabled {
  pointer-events: none;

  /deep/ .el-upload {
    background-color: #d9d9d9;
  }
}
</style>

<script>
import {
  saveSproutVideoResult,
  getSproutVideoUploadToken,
  getSproutVideoUploadSetting,
  getSproutVideoUploadSettingNonCA,
} from "@/service/videoAppointment.service";
import { saveClientSideError } from "../../service/common.service";

import { convertFileSize } from "../../config/mUtils";

export default {
  props: {
    type: {
      type: Number,
      default: 0,
      validator: (value) => [0, 1].contains(value),
    },
    dataIn: {
      courseActivationId: Number,
      weekLabel: String,
      courseId: Number,
      title: String,
      fileId: Number,
    },
  },
  data() {
    return {
      showError: false,
      errorMessage: "",
      submitBtnClass: "info",
      submitBtnDisable: true,
      isLoading: false,
      baseUrl: "https://api.sproutvideo.com/v1/videos",
      url: "",
      params: {
        token: "",
        title: "",
        description: "",
        folder_id: "",
      },
      isUploadSuccess: false,
      isUploading: false,
      uploadingText: "",
      uploadTime: "",
      isReplace: false,
      uploadDisabled: false,
      displayProgress: false,
      fileData: {
        name: "",
        size: 0,
        progressPercent: 0,
        successFlag: false,
      },
      extensions: [
        "asf",
        "avi",
        "divx",
        "dv",
        "dvx",
        "flv",
        "gvi",
        "m1pg",
        "m1v",
        "m21",
        "m2t",
        "m2ts",
        "m2v",
        "m4e",
        "m4u",
        "m4v",
        "mjp",
        "mod",
        "moov",
        "mov",
        "movie",
        "mp21",
        "mp3",
        "mp4",
        "mpe",
        "mpeg",
        "mpg",
        "mpv2",
        "mts",
        "qt",
        "qtch",
        "qtz",
        "rm",
        "rmvb",
        "rv",
        "svi",
        "swi",
        "tivo",
        "tod",
        "tp",
        "ts",
        "vfw",
        "vid",
        "vob",
        "vp6",
        "vp7",
        "wm",
        "wmv",
        "xvid",
        "yuv",
        "webm",
        "mxf",
        "ogv",
        "f4v",
        "mkv",
        "gif",
      ],
      fileTypeList: [],
    };
  },
  components: {},
  created() {
    this.init();
  },
  methods: {
    init() {
      this.getSupportedFileTypeList();

      if (!!this.dataIn) {
        this.params.folder_id = "";
        this.isLoading = true;
        this.uploadDisabled = false;
        (this.displayProgress = false),
          (this.fileData = {
            name: "",
            size: 0,
            progressPercent: 0,
            successFlag: false,
          });
        this.getToken();

        if (this.type != 0) {
          getSproutVideoUploadSettingNonCA(
            this.type,
            this.dataIn.courseId,
            this.dataIn.title
          )
            .then((result) => {
              if (!!result && result.success) {
                this.params.title = result.data.Title;
                this.params.description = result.data.Description;
                this.params.folder_id = result.data.FolderId;
                this.params.privacy = 2;
                this.params.download_sd = false;
                this.params.download_hd = false;
                this.params.download_source = false;
                if (!!result.data.SproutId) {
                  this.isReplace = true;
                } else {
                  this.isReplace = false;
                }
                if (!String.isNullOrEmpty(result.data.NotificationUrl)) {
                  this.params.notification_url = result.data.NotificationUrl;
                }
                this.url = this.baseUrl;
                this.uploadTime = result.data.UploadTime;

                if (!this.params.folder_id) {
                  this.$message.error("创建SproutVideo文件夹失败");
                }
              } else {
                this.$message.error(result.message);
              }
              this.checkLoading();
            })
            .catch(() => {});
        } else {
          getSproutVideoUploadSetting(this.dataIn.courseActivationId)
            .then((result) => {
              if (!!result && result.success) {
                this.params.title = result.data.Title;
                this.params.description = result.data.Description;
                this.params.folder_id = result.data.FolderId;
                this.params.allowed_domains =
                  "localhost,*.azurewebsites.net,*.speedupedu.com";
                if (!!result.data.SproutId) {
                  //this.url = this.baseUrl + "/"+result.data.SproutId+"/replace";
                  this.isReplace = true;
                } else {
                  this.isReplace = false;
                }
                if (!String.isNullOrEmpty(result.data.NotificationUrl)) {
                  this.params.notification_url = result.data.NotificationUrl;
                }
                this.url = this.baseUrl;
                this.uploadTime = result.data.UploadTime;

                if (!this.params.folder_id) {
                  this.$message.error("创建SproutVideo文件夹失败");
                }
              } else {
                this.$message.error(result.message);
              }
              this.checkLoading();
            })
            .catch(() => {});
        }
      }
    },
    getSupportedFileTypeList() {
      this.fileTypeList = File.convertToFileTypeList(this.extensions);
    },
    getToken(isUploadError) {
      if (!this.params.token) {
        getSproutVideoUploadToken().then((result) => {
          if (result && result.success) {
            this.params.token = result.data;
          } else {
            this.$message.error("获取token失败" + result.message);
          }
          this.checkLoading();
          if (!!isUploadError) {
            this.isUploading = false;
          }
        });
      }
    },
    checkLoading() {
      if (!!this.params.token && !!this.params.folder_id) {
        this.isLoading = false;
      }
    },
    onFileChange() {},
    beforeUpload(file) {
      if (file.size > 1024 * 1024 * 1024 * 10) {
        this.showError = true;
        this.errorMessage = `文件 ${file.name} 大小超出限制（10G）`;
        return false;
      }

      let fileType = file.getMimeType();
      if (this.fileTypeList.indexOf(fileType) < 0) {
        this.showError = true;
        this.errorMessage = `文件格式${fileType}错误`;
        return false;
      }

      this.clearMessages();
      this.isUploadSuccess = false;

      this.uploadingText =
        "正在上传视频" + file.name + "。上传过程中，文件上传窗口无法关闭。";

      this.fileData = {
        name: file.name,
        size: file.size,
        progressPercent: 0,
        successFlag: false,
      };
      (this.displayProgress = true), (this.isUploading = true);
      this.$emit("beforeUpload");
    },
    onUploadSuccess(response, file, fileList) {
      this.fileData.progressPercent = 99;
      this.params.token = "";
      this.isUploadSuccess = true;
      this.submitBtnClass = "info";
      this.clearMessages();
      this.$refs.upload.clearFiles();
      this.$emit("fileUploaded");

      this.saveResult(response, file.name, file.size);
    },
    onUploadError(err) {
      this.params.token = "";
      this.getToken(true);

      this.isUploadSuccess = false;
      this.showError = true;
      if (!!err && !!err.message) {
        try {
          saveClientSideError("SproutVideo上传出错", err.message);
        } catch (e) {}
      }
      this.errorMessage = "上传出错";
      this.$emit("fileUploadError");
    },
    onProgress(event, file, fileList) {
      let percent = parseInt(event.percent.toFixed(0));
      if (percent > 99) {
        percent = 99;
      }
      this.fileData.progressPercent = percent;
    },
    clearMessages() {
      this.showError = false;
      this.errorMessage = "";
    },
    saveResult(sproutVideo, fileName, size) {
      saveSproutVideoResult(
        sproutVideo,
        fileName,
        size,
        this.dataIn.courseActivationId,
        this.dataIn.fileId
      )
        .then((result) => {
          if (result && result.success) {
            this.$emit(
              "success",
              fileName,
              this.dataIn.courseActivationId,
              result.data
            );
            // this.$notify({
            //   title: "提示",
            //   message: "视频文件" + fileName + "上传成功!",
            //   type: "success",
            //   duration: 0,
            // });
          } else {
            let msg = "保存视频数据失败";
            if (!!result.message) {
              msg += "-" + result.message;
            }

            this.$message({
              showClose: true,
              message: msg,
              type: "error",
              duration: 0,
            });
          }

          this.fileData.successFlag = true;
          this.fileData.progressPercent = 100;
          this.isUploading = false;
          this.uploadDisabled = true;
        })
        .catch(() => {
          this.isUploading = false;
        });
    },
    convertFileSize(fileSize) {
      return convertFileSize(fileSize);
    },
  },
  watch: {
    dataIn: function () {
      this.init();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/sproutVideo/videoUpload.vue